import 'jquery-validation';
import Utils from '../../util/utils';
const SubsidyForm = {

    _jForm: $('.jsSubsidyForm'),
    email: '',
    init() {
        this.initValidations();
    },
    
    initValidations() {
        const me = this;
        jQuery.validator.addMethod('noSpace', function(value) { 
            return value.indexOf(' ') < 0 && value != ''; 
          }, 'No space please and dont leave it empty');
        if (this._jForm.length > 0) {
            var config = Utils.getValidationConfig({
                ignore: [],
                rules: {
                    txtName: {
                        required: true,
                        // minlength: 2,
                    },
                    txtEmail: {
                        required: true,
                        noSpace: true,
                        // customemail: true,
                    },

                    txtCompanyName: {
                        required: true,
                    },

                    txtPhnno: {
                        required: true,
                        minlength: 10,
                        maxlength: 10,
                        noSpace: true,
                        number: true,
                    },
                    // txtMessage: {
                    //     required: true,
                    //     // minlength: 10,
                    // },
                },
                messages: {
                    txtName: {
                        required: 'Please provide your Name',
                        // minlength: 'Please provide your complete Name',
                    },
                    txtEmail: {
                        required: 'Please provide your Email address',
                        // customemail: 'Please provide a valid e-mail address',
                    },
                    txtCompanyName: {
                        required: 'Please provide your Company name',
                    },
                    txtPhnno: {
                        required: 'Please provide your Phone number',
                        minlength: 'Please provide at least 10 numbers',
                        maxlength: 'Please do not enter more than 10 digits',
                    },
                    // txtMessage: {
                    //     required: 'Please provide your Message',
                    // },
                },
                submitHandler: function() {

                    me.onFormSubmit();

                },
            });
            this._jForm.validate(config);
        }
    },
    onFormSubmit() {
      if (this._jForm.valid()) {
          var $form = this._jForm;
          var unindexed_array = $form.serializeArray();
          var indexed_array = {};
          jQuery.map(unindexed_array, function(n) {
              indexed_array[n['name']] = n['value'];
          });
          var formData = {};
          formData = indexed_array;
          Utils.sendRequest({
              'url': '/wp-admin/admin-ajax.php',
              'data': {
                  'action': 'getSubSidyForm',
                  'formData': formData,
              },
              'onDone': $.proxy(this._onSuccess, this),
          });
      }
      return false;
  },
  _onSuccess(response) {
      this._jForm[0].reset();
      Utils.showLoader(true);
      Utils.notify({
          'message': response.message,
      });
        
  },
}
export default SubsidyForm;




// WEBPACK FOOTER //
// ./scripts/modules/forms/subsidy_form.js